import request from '@/utils/request'

export function getOpenMarketInfo(agentId, entrRqstFomNo, opmkNo) {
    let params = {
        dealCd: agentId,
        entrRqstFomNo: entrRqstFomNo,
        opmkNo: opmkNo
    }
    return request({
        url: `/ococ/datacapture/openmarket/getFormInfo`,
        method: 'get',
        params
    })
}

export function getSamSungInfo(agentId, entrRqstFomNo, opmkNo, trmMdlCd, ppCd) {
    let params = {
        dealCd: agentId,
        entrRqstFomNo: entrRqstFomNo,
        opmkNo: opmkNo,
        trmMdlCd: trmMdlCd,
        ppCd: ppCd
    }
    return request({
        url: `/ococ/datacapture/openmarket/getFormSamSungInfo`,
        method: 'get',
        params
    })
}

export function getDeviceList(agentId, entrRqstFomNo) {
    let params = {
        dealCd: agentId,
        entrRqstFomNo: entrRqstFomNo
    }
    return request({
        url: `/ococ/datacapture/openmarket/getDiviceModelInfo`,
        method: 'get',
        params
    })
}

export function getApplServiceKindInfo(agentId, entrRqstFomNo ,type) {
    let params = {
        codeType: '',
        dealCd: agentId,
        entrRqstFomNo: entrRqstFomNo
    }
    if(type === 'colors') {
        params.codeType = 'COLR'
    } else if(type === 'choc') {
        params.codeType = 'CHOC'
    } else if(type === 'disc') {
        params.codeType = 'DISC'
    } else if(type === 'duty') { //의무약정
        params.codeType = 'DUTY'
    } else if(type === 'rotr') { //라우터약정
        params.codeType = 'ROTR' 
    } else if(type === 'mcco') { //라우터약정
        params.codeType = 'MCCO' 
    }
    return request({
        url: `/ococ/datacapture/openmarket/getApplServiceKindInfo`,
        method: 'get',
        params
    })
}

export function getPayStyleInfo(ssn, dealCd, entrRqstFomNo, trmMdlCd) {
    let params = {
        custBday: ssn,
        dealCd: dealCd,
        entrRqstFomNo: entrRqstFomNo,
        trmMdlCd: trmMdlCd
    }
    return request({
        url: `/ococ/datacapture/openmarket/getPayStyleInfo`,
        method: 'get',
        params
    })

}

export function getSelfPhonePay(aplcTlno, appfNo) {
    let params = `${aplcTlno.substr(0,3)}0${aplcTlno.substr(3,8)}`
    return request({
        url: `/ococ/datacapture/openmarket/getSelfPhonePayWithAppfNo`,
        method: 'get',
        headers: {
            'aplcTlno': params, //success 010077008060
            'appfNo': appfNo
        }, 
    })
}

// 맘대로 폰 요금제 조회
export function getLssDaydInsLmtList(phoneMdlCd) {
    let params = {
        phoneModelCd: phoneMdlCd,
        hphnLbciClssCd:"HPEW"

    }
    return request({
        url: `/ococ/datacapture/v1/ushop/LssDaydInsLmtList`,
        method: 'get',
        params
    })
}